<template>
    <el-dialog class="editor-dialog" :visible.sync="visible" :show-close="false" fullscreen>
        <div ref="pdfContainer" class="pdf-container">
          <div style="position:fixed;right:20px;top:0;z-index:3000;height:40px;line-height:40px;color:white">
            <span>第 {{ currentPage }} 页  共 {{ numPages }} 页</span>
          </div>
          <div class="toolbar">
            <el-input-number size="mini" v-model="currentPage" @change="jumpToPage" :min="1" :max="numPages" style="margin-right:5px"></el-input-number>
            <button @click="zoomIn" :disabled="scale >= maxScale">放大</button>
            <button @click="zoomOut" :disabled="scale <= minScale">缩小</button>
            <button @click="rotateClockwise">旋转</button>
            <button @click="reset">重置</button>
            <button @click="downloadContract(pdfUrl)">下载</button>
            <!-- <input v-model="searchText" placeholder="搜索文本" @keyup.enter="searchPDF" />
            <button @click="searchPDF">搜索</button> -->
            <button @click="visible=false">关闭</button>            
          </div>
          <div class="pdf-canvas" ref="pdfCanvasDiv">
            <canvas ref="pdfCanvas" class="canvas"></canvas>
          </div>
        </div>        
    </el-dialog>
  </template>
  
  <script>
  import * as pdfjsLib from 'pdfjs-dist/build/pdf';
  import 'pdfjs-dist/build/pdf.worker.entry';
  import fileSave from 'file-saver'
  export default {
    name: 'PDFViewer',
    data() {
      return {
        pdfDocument: null,
        pdfUrl:'',
        filename:'',
        currentPage: 1,
        numPages: 0,
        loadingTask: null,
        scale: 1.4,
        minScale: 0.2,
        maxScale: 5,
        rotation: 0,
        searchText: '',
        visible: false
      };
    },
    mounted() {
      this.loadPDF();
    },
    methods: {
      async loadPDF() {
        try {
          this.loadingTask = pdfjsLib.getDocument(this.pdfUrl);
          this.pdfDocument = await this.loadingTask.promise;
          this.numPages = this.pdfDocument.numPages;
          this.renderPage(this.currentPage);
        } catch (error) {
          console.error('Error loading PDF:', error);
        }
      },
      renderPage(pageNumber) {
        this.pdfDocument.getPage(pageNumber).then(page => {
          const canvas = this.$refs.pdfCanvas;
          const context = canvas.getContext('2d');
  
          const viewport = page.getViewport({
            scale: this.scale,
            rotation: this.rotation
          });
          canvas.width = viewport.width;
          canvas.height = viewport.height;
  
          page.render({
            canvasContext: context,
            viewport: viewport
          }).promise.then(() => {
            this.updateSearchHighlights(page);
          });
        });
      },
      jumpToPage() {
        if (this.currentPage >= 1 && this.currentPage <= this.numPages) {
          this.renderPage(this.currentPage);
        }
      },
      zoomIn() {
        if (this.scale < this.maxScale) {
          this.scale *= 1.1;
          this.renderPage(this.currentPage);
        }
      },
      zoomOut() {
        if (this.scale > this.minScale) {
          this.scale /= 1.1;
          this.renderPage(this.currentPage);
        }
      },
      reset() {
        this.scale = 1.4;
        this.rotation= 0
        this.currentPage=1
        this.renderPage(this.currentPage);
      },
      rotateClockwise() {
        this.rotation = (this.rotation + 90) % 360;
        this.renderPage(this.currentPage);
      },
      searchPDF() {
        if (this.searchText.trim()) {
          // this.currentPage = 1;
          this.renderPage(this.currentPage);
        }
      },
      updateSearchHighlights(page) {
        if (this.searchText.trim()) {
          page.getTextContent().then(content => {
            const textItems = content.items;
            const highlights = [];
  
            textItems.forEach(item => {
              const text = item.str.toLowerCase();
              const searchText = this.searchText.toLowerCase();
  
              if (text.includes(searchText)) {
                const startIndex = text.indexOf(searchText);
                const endIndex = startIndex + searchText.length;
  
                const highlightStart = {
                  x: item.x + (item.width * (startIndex / text.length)),
                  y: item.y
                };
  
                const highlightEnd = {
                  x: item.x + (item.width * (endIndex / text.length)),
                  y: item.y
                };
  
                highlights.push([highlightStart, highlightEnd]);
              }
            });
  
            this.highlightText(highlights);
          });
        }
      },
      highlightText(highlights) {
        const canvas = this.$refs.pdfCanvas;
        const context = canvas.getContext('2d');
  
        context.save();
        context.fillStyle = 'rgba(255, 0, 0, 0.5)';
        highlights.forEach(([start, end]) => {
          context.fillRect(start.x, start.y, end.x - start.x, 15); // 假设字体大小为 15
        });
        context.restore();
      },
      downloadContract(url){
        this.$axios({
          method:'get',
          url,
          responseType:'arraybuffer'
        }).then(data=>{
          const blob = new Blob([data.data], { type: 'application/octet-stream' });
          fileSave.saveAs(blob,this.filename)
        }).catch(error=>{
          reject(error.toString())
        })
      }
    }
  };
  </script>
  
  <style scoped>
  .editor-dialog>>>.el-dialog__header {
    padding: 0;
  }
  .editor-dialog>>>.el-dialog__body {
    padding:0;
  }
  .editor-dialog>>>.el-dialog__title {
    display: none;
  }
  .pdf-container {
    position: relative;
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
  }  
  .toolbar {
    position: fixed; /* 固定在页面顶部 */
    top: 0;
    left: 0;
    width: 100%; /* 工具栏宽度占满整个屏幕 */
    background-color: #333; /* 背景颜色 */
    color: white; /* 文字颜色 */
    padding: 5px 0; /* 上下内边距 */
    text-align: center; /* 文字居中 */
    z-index: 1000; /* 确保工具栏在最上层 */
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center;     /* 垂直居中 */
  }  
  .toolbar button {
    margin: 0 10px; /* 按钮之间的间距 */
    padding: 5px 15px; /* 按钮内边距 */
    background-color: #555; /* 按钮背景颜色 */
    color: white; /* 按钮文字颜色 */
    border: none; /* 去掉边框 */
    border-radius: 5px; /* 圆角 */
    cursor: pointer; /* 鼠标悬停时的样式 */
  }
  .toolbar button:hover {
    background-color: #777; /* 鼠标悬停时的背景颜色 */
  }
  .pdf-canvas {
    padding-top:30px;
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center;     /* 垂直居中 */
  }
  </style>